import { ArrowLeft, Zoomit } from '@zoomit/icons';
import { Link } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';
import ReviewCircleProgress from '../shared/ReviewCircleProgress';
import ReviewBox from './ReviewBox';

type Props = {
  score: number;
  reviewArticleUrl: string | null;
};

const ZoomitReviewBox = (props: Props) => {
  const { score, reviewArticleUrl } = props;
  const appName = useWebKitCustomization((state) => state.tenantPersianTitle);

  return reviewArticleUrl ? (
    <Link href={reviewArticleUrl}>
      <ReviewBox>
        <ReviewCircleProgress rate={String(score)} />
        <div className="xs:items-center flex flex-col md:items-start">
          <div className="flex items-center gap-1 whitespace-nowrap">
            <Zoomit fill="#E4002B" />
            <Typography variant="subhead-bold" lineHeight={2}>
              امتیاز {appName}
            </Typography>
          </div>
          <div className="review-link text-grey1 text-subhead hover:text-text-hover hover:[&>svg]:fill- flex h-[24px] items-center gap-2 p-0 leading-loose whitespace-nowrap">
            مشاهده بررسی
            <ArrowLeft size="sm" fill={cssVar(theme.grey1)} />
          </div>
        </div>
      </ReviewBox>
    </Link>
  ) : (
    <ReviewBox>
      <ReviewCircleProgress rate={String(score)} />
      <div className="xs:items-center flex flex-col md:items-start">
        <div className="flex items-center gap-1">
          <Zoomit fill={cssVar(theme.primary1)} />
          <Typography variant="subhead-bold" lineHeight={2}>
            امتیاز {appName}
          </Typography>
        </div>
      </div>
    </ReviewBox>
  );
};

export default ZoomitReviewBox;
